import React, {useEffect, useState} from "react";
import {
    ArrowUpDownIcon,
    EnquiryDownIcon,
    EnquiryTooltip,
    FooterBottomSection,
    FooterInfoSection,
    FooterSectionLabel,
    FooterSectionList,
} from "./FooterStyled";
import PropTypes from "prop-types";
import Anchor from "../../HTMLEntities/Anchor";
import {footerData} from "../utils";

const FooterBottomPartInfo = ({item, isMobile, footerHandler, footerKey, accordionClass}) => {
    const [isOpen, setIsOpen] = useState(false);
    let overflowUnset = isOpen === true;
    useEffect(() => {
        setIsOpen(false);
    }, [accordionClass]);

    const enquiryToolTipHandler = (linkText) => {
        if (linkText === "Advertising/Sales enquiries") {
            setIsOpen((prevState) => !prevState);
        }
    };

    return (
        <FooterInfoSection key={footerKey}>
            <FooterSectionLabel onClick={() => footerHandler(footerKey)}>
                {item.group}
                {isMobile && <ArrowUpDownIcon accordionClass={accordionClass} />}
            </FooterSectionLabel>
            <FooterSectionList accordionClass={accordionClass} overflowUnset={overflowUnset}>
                <ul>
                    {item.gnbFooterLinksData.map((nestedItem, index) => {
                        let aircClass = "";
                        if (
                            nestedItem.linksText === "AIRC - Certification for recruitment services"
                        ) {
                            aircClass = "aircLogo";
                        }

                        return (
                            <li
                                key={index}
                                onClick={() => enquiryToolTipHandler(nestedItem.linksText)}
                                className={aircClass}
                            >
                                <Anchor
                                    linkHref={nestedItem.linksUrl}
                                    linkLabel={nestedItem.linksText}
                                    {...(nestedItem?.linksRel ? {rel: "nofollow"} : "")}
                                    // debug={true}
                                    disabledExternalValidation={true}
                                    displayStyle={{
                                        laptop: {
                                            color: "#000",
                                            marginBottom: "5px",
                                            display: "inline-block",
                                            outline: "0px",
                                            maxWidth: "100%",
                                            width: "auto",
                                        },
                                        mobile: {
                                            color: "#000",
                                            marginBottom: "5px",
                                            display: "inline-block",
                                            outline: "0px",
                                            maxWidth: "100%",
                                            width: "100%",
                                        },
                                    }}
                                />
                                {nestedItem.linksText === "Advertising/Sales enquiries" && (
                                    <EnquiryDownIcon />
                                )}
                                {isOpen && nestedItem.linksText === "Advertising/Sales enquiries" && (
                                    <EnquiryTooltip>
                                        Nandita Bandopdhyay
                                        <br />
                                        <a href="mailto:nandita@shiksha.com">nandita@shiksha.com</a>
                                    </EnquiryTooltip>
                                )}
                            </li>
                        );
                    })}
                </ul>
            </FooterSectionList>
        </FooterInfoSection>
    );
};
FooterBottomPartInfo.propTypes = {
    item: PropTypes.object,
    footerHandler: PropTypes.func,
    isMobile: PropTypes.bool,
    footerKey: PropTypes.string,
    accordionClass: PropTypes.string,
};
class FooterBottomPart extends React.Component {
    generateFooterBottomPart() {
        const {isMobile} = this.props;
        return footerData.map((item, index) => {
            let footerKey = "footerBtmGrp_" + index;
            let accordionClass = this.props.isActive(footerKey) ? "active" : "";
            return (
                <FooterBottomPartInfo
                    isMobile={isMobile}
                    footerHandler={this.props.footerHandler}
                    key={footerKey}
                    footerKey={footerKey}
                    accordionClass={accordionClass}
                    item={item}
                />
            );
        });
    }

    render() {
        const {isMobile} = this.props;
        let footerLeftItems = [];
        if (typeof footerData != "undefined") {
            footerLeftItems = this.generateFooterBottomPart(isMobile);
        }

        return <FooterBottomSection>{footerLeftItems}</FooterBottomSection>;
    }
}
FooterBottomPart.propTypes = {
    footerData: PropTypes.array,
    footerHandler: PropTypes.func,
    isActive: PropTypes.func,
    isMobile: PropTypes.bool,
};
export default FooterBottomPart;
